import templateUrl from 'emun.invoice/credit-memo-lines-table.htm'

export default {
    require: {
        container: '^creditMemo'
    },
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
};
